import { render, staticRenderFns } from "./CaseTableTree.vue?vue&type=template&id=55ae7e12&scoped=true&"
import script from "./CaseTableTree.vue?vue&type=script&lang=ts&"
export * from "./CaseTableTree.vue?vue&type=script&lang=ts&"
import style0 from "./CaseTableTree.vue?vue&type=style&index=0&id=55ae7e12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae7e12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
